import { ParentDashboardCard } from "@outschool/gql-backend-generated";

import {
  CardDefinition,
  FeedRenderableCard,
  ListRenderableCard
} from "../CardDefinition";

export const type = "upcoming";

export type NewFromCardDefinition = CardDefinition & {
  title: string;
  url: string;
  showMoreUrl: string;
  showMoreText: string;
};

export function getRenderData(
  card: Pick<ParentDashboardCard, "id">
): FeedRenderableCard {
  const prototype = definitions.find(d => d.id === card.id);
  // @ts-ignore TS(2322): Type '{ id: string; type?: string | undefined; tit... Remove this comment to see the full error message
  return { ...prototype, ...card };
}

export function getListRenderData(argument: string): ListRenderableCard {
  const card = definitions.find(d => d.id === argument);
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'any[]'.
  return { ...card, listings: null };
}

export const NEW_FROM_TITLE = Object.freeze({
  SAVED_CLASSES: "Upcoming and saved classes",
  FAVORITE_TEACHERS: "Upcoming classes from teachers you follow"
});

export const definitions: NewFromCardDefinition[] = [
  {
    type,
    id: "saved-classes",
    title: NEW_FROM_TITLE.SAVED_CLASSES,
    url: "/dashboard/upcoming/saved-classes",
    showMoreUrl: "/account/saved-classes",
    showMoreText: "See all saved classes"
  },
  {
    type,
    id: "favorite-teachers",
    title: NEW_FROM_TITLE.FAVORITE_TEACHERS,
    url: "/dashboard/upcoming/favorite-teachers",
    showMoreUrl: "/account/followed-teachers",
    showMoreText: "See all teachers you follow"
  }
];
